import { HTMLAttributes, PropsWithChildren } from 'react'
import { cn } from '../utils'

export type CardProps = HTMLAttributes<HTMLDivElement>

export default function Card({
  className,
  children,
  ...props
}: PropsWithChildren<CardProps>) {
  return (
    <div
      className={cn(
        'cmp-card',
        'dark:bg-cool-gray-800',
        'dark:border',
        'dark:rounded-lg',
        className
      )}
      {...props}
    >
      {children}
    </div>
  )
}
